import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import utils from "../../../utils/validateScanner"
export default {
  name: 'SorterBagging',
  mixins: [utils],
  components: {
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      userHubId: 0,
      showBagSealNoModel: false,
      bagSealNumber: '',
      awbBag: '',
      weight: '',
      hubName: '',
      baginBagNo: '',
      baginBagStatus: '',
      baginBagType: '',
      reason: '',
      oldSealNo: '',
      newSealNo: '',
      oldSealNoErr: '',
      newSealNoErr: '',
      reasonErr: '',
      flagUpdateSealNo: false,
      inScanList: [],
      awbBagErr: '',
      printBagStickerNo: '',
      flagGerateBag: false,
      input: '',
      bagDetails: '',
      barcodeinput: false,
      timerenable: 1000,
      timerdisable: 1200,
      barcodecheck: 0,
      isLoading: false,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      BagLoading: false,
      XBSealModel: false,
      xbsealreason: '',
      xbsealreasonErr: '',
      IsAllowXBSeal: false,
      timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[],
      checkedType:"sorterbagging",
      shipmentForColor:'',
      isDirectbaggingEnabled:false,
            bayTypeList:[
				{
	        value: 1,
	        text: "Direct"
	      }, {
	        value: 2,
	        text: "PTL"
	      }
			],
  bayTypeData:{
    text: 'Direct',
    value: 1,
  },
  bayTypeName:'Direct',
  BayNoList:[],
  BayNoData:{
    value: "",
    text: "",
  },
  isPTL: false,
  bayNo:"",
  PTLNoList:[],
  PtlNoData:{
    value: "",
    text: "",
  },
  PtlNo:"",
  bagtype:"",
  route:"",
Destination:"",
bagDestinationHubId:null,
groupId:null,
laneDetail:'',
errorBagSealNo: '',
sorterConfigFileName : '',
cwbcode : 0,
iscwbFacility : false,
BagNoForColor:'',

}
},
  created: function() {},
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
    this.createdBy = userdetail[0].email;
    this.userid = parseInt(userdetail[0].userid, 10); 
    this.today = new Date()
    this.getHubName(this.userHubId);
    this.getDirectbaggingHub();
    this.sorterConfigFile();
    this.loadBayNos();
  },
  created() {},
  methods: {
    validateBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
    checkBarcode(obj) {
      var obj = Number(obj);
      this.barcodecheck = this.barcodecheck + obj;
      if (this.barcodecheck == 1) {
        setTimeout(function() {
          document.getElementById("bagsealno").disabled = true;
        }, this.timerenable);
      }
    },
    getHubName(hubid){
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    getDirectbaggingHub() {
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'getdirectbaggingdetails?currentHubId=' + this.userHubId,
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				  'requestfrom': "WEB",
				}
			  })
			  .then(result => {
				if (result.data.ResultCode == 100) {
					this.isDirectbaggingEnabled = true;
				}

			  }, error => {
				console.error(error)
			  })
		  },
    checkField(){
      if(this.isDirectbaggingEnabled && this.checkedType === 'directbagging'){
        this.$router.replace("/DirectBagging")
      }
      else if(this.isDirectbaggingEnabled==false && this.checkedType === 'directbagging'){
        this.$alertify.error("Directbagging is not available for this location!");
        this.checkedType="sorterbagging";
      }
      else if(this.checkedType === 'bagging'){
        this.$router.replace("/BaginProcess")
      }
    },
    selectBayType(obj) {
      this.bayTypeData = obj
      this.bayTypeName = obj.text
      this.resetfeilds();
      if(this.bayTypeName=="PTL")
      {
        this.isPTL=true;
      }else{
        this.isPTL=false;
      }
      this.loadBayNos();
    },
    sorterConfigFile(){
      axios({
        method: 'GET',
        url : apiUrl.api_url_hubops + "getActiveFileForHub?CurrentHubID="+ this.userHubId,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': "WEB",
          'token': this.token
        }
      })
      .then(result => {
        if(result.data.ReturnCode == 100) {
          this.sorterConfigFileName = result.data.ResponseData;
        } else {
          this.sorterConfigFileName = "No Active Config File Found For this Hub"; 
        }
      }, error => {
        console.error(error)
      })
    },
    loadBayNos(){
      axios({
        method: 'GET',
          url: apiUrl.api_url_hubops + "fetchBayNosforSorterBagging?currentHubId="+this.userHubId+ "&bayType=" + this.bayTypeName,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var bayNos = result.data.ResponseData;
            for(var i = 0;i<bayNos.length;i++){
              this.BayNoList.push({
                text:bayNos[i]+" ",
                value:bayNos[i]
              })
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    selectedBayNo(obj) {
      this.PTLNoList=[],
      this.PtlNoData={
        value: "",
        text: "",
      },
      this.PtlNo="",
      this.BayNoData = obj;
      this.bayNo=obj.value;

      if(this.bayTypeName=="PTL"){
        axios({
            method: 'GET',
              url: apiUrl.api_url_hubops + "fetchPtlIdsforSorterBagging?currentHubId="+this.userHubId+ "&bayNo=" + this.bayNo,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
                'requestfrom': "WEB",
                'token': this.token
              }
            })
            .then(result => {
              if (result.data.ResultCode == 100) {
                var ptlNos = result.data.ResponseData;
                for(var i = 0;i<ptlNos.length;i++){
                  this.PTLNoList.push({
                    text:ptlNos[i]+" ",
                    value:ptlNos[i]
                  })
                }
              } else {
                this.$alertify.error(result.data.ReturnMessage)
              }
            }, error => {
              console.error(error)
            })
      }
      else{
      this.fetchBagDetails(obj.value);
    }
    },
    selectedPTLNo(obj){
      this.PtlNoData=obj;
      this.PtlNo=obj.value;
      this.fetchBagDetails();
    },
    fetchBagDetails(){
      this.cwbcode = 0;
      this.iscwbFacility = false;
    let url=apiUrl.api_url_hubops + "getBayDetailsForBayType?currentHubId="+this.userHubId+"&baytype="+this.bayTypeName+"&bayNo="+this.bayNo;
      if(this.bayTypeName=='PTL'){
        url=url+"&ptlid="+this.PtlNo;
      }
      axios({
          method: 'GET',
            url: url,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              var result = result.data.ResponseData;
              this.Destination = result.destinationHubName;
              this.route = result.route;
              this.bagtype = result.bagType;
              this.bagDestinationHubId = result.destinationHubId ;
              this.groupId = result.groupDetail;
              this.laneDetail = result.laneDetail;
              this.cwbcode = result.cwbcode;
              this.iscwbFacility = result.iscwbFacility;
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
    },
    resetfeilds(){
      this.bagtype="",
      this.route="",
    this.Destination="",
    this.BayNoList=[],
    this.BayNoData={
      value: "",
      text: "",
    },
    this.bayNo='',
    this.PTLNoList=[],
    this.PtlNoData={
      value: "",
      text: "",
    },
    this.PtlNo="",
    this.resetValidator()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    generateBag(type) {
      if (type == "IsXbSeal" && this.xbsealreason == '') {
        this.xbsealreasonErr = "Select Reason"
        return false
      } else {
        this.xbsealreasonErr = ""
        this.BagLoading = true
        this.flagGerateBag = true
        this.flagUpdateSealNo = false
        this.awbBag = ""
        this.awbBagErr = ""
        this.input = {
          "currentHubId": this.userHubId,
          "currentHubName": this.hubName,
          "bagNumber": this.bagSealNumber,
          "bagDestinationHubName":this.Destination,
          "bagDestinationHubId": this.bagDestinationHubId,
          "bagType": this.bagtype,
          "routeMode": this.route,
          "groupId": this.groupId,
          "createdBy": this.createdBy,
          "isManualEntry": this.barcodeinput == true ? false : true,
          "bayId" : this.bayNo,
          "cwbcode" : this.cwbcode,
          "statusMarkedFrom": "WEB"
            }
          this.PtlNo ? this.input.ptlId = this.PtlNo : '';
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'generateBagForSorterBagging',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.BagLoading = false
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.baginBagNo = result.data.BagNo.toUpperCase()
              this.baginBagStatus = "BagOpen"
              this.baginBagType = this.bagtype
              this.flagUpdateSealNo = true
              this.IsAllowXBSeal = false
              this.xbsealreason = ''
              this.xbsealreasonErr = ''
              this.XBSealModel = false
              if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
                this.colorCodeBag = result.data.lossCategorization.colorCode;
                this.colorIconBag = result.data.lossCategorization.icon;
              }
              this.$refs.awbBag.focus()
              this.$alertify.success(result.data.ReturnMessage)
               if (this.isValidPriorityBagSeal(this.bagSealNumber)) {
                 this.showAutoClosePopup(
                   "Priority seal scanned! Add priority shipments only."
                 );
               }
            }else {
              this.invalidTokenModal = false
              this.XBSealModel = false
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.flagGerateBag = false
            user_tracker.checkUserIP(this.userData[0], "BaginProcess_GenerateBag", this.$route.path , this.input);
          }, error => {
            this.BagLoading = false
            this.flagGerateBag = false
            console.error(error)
          })
      }
    },
     closeAutoPopup() {
      clearTimeout(this.autoPopupTimer);
      this.showAutoPopup = false;
    },
    searchBag() {
      
      if (this.bagSealNumber.length <= 4 && this.barcodeinput == true) {
        this.bagSealNumber = '',
          this.barcodecheck = 0,
          setTimeout(function() {
            document.getElementById("bagsealno").disabled = false;
          }, this.timerdisable);
        this.$alertify.error("Use Barcode Scanner Only Or Disable Scanner Input For Manual Input")
        return false;
      }

      if (this.bagSealNumber) {
        this.errorBagSealNo = ''
        this.cwbcode = 0;
        this.iscwbFacility = false;
        this.BagLoading = true;
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'searchSorterBasedBagDetails?BagNo=' + this.bagSealNumber +'&currentHubId='+this.userHubId,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.BagLoading = false;
            this.BagNoForColor = '';
          if (result.data.ResultCode == 100 && result.data.ResponseData.length > 0) {

            if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
              this.colorCodeBag = result.data.lossCategorization.colorCode;
              this.colorIconBag = result.data.lossCategorization.icon;
            } 

              this.invalidTokenModal = false
              var response = result.data.ResponseData[0]
              this.baginBagNo = response.bagno.toUpperCase()
              this.baginBagStatus = response.bagstatus
              this.baginBagType = response.bagtype
              this.cwbcode = response.iscwb
              this.iscwbFacility = response.iscwbFacility

              var bayDetails = result.data.bayDetails;
              this.bayTypeData = {
                text : bayDetails.bayType
              };
              this.bayTypeName = bayDetails.bayType;
              this.groupId = (bayDetails.groupDetail) ? bayDetails.groupDetail : this.groupId;
              this.laneDetail = bayDetails.laneDetail;
              this.bayNo = bayDetails.bayno;
              this.BayNoData = {
                text: this.bayNo,
                value: this.bayNo
              };
              this.isPTL = false;
              if(bayDetails.ptlid)
              {
                this.isPTL = true;
                this.PtlNo = bayDetails.ptlid;
                this.PtlNoData = {
                  text: this.PtlNo,
                  value: this.PtlNo
                };
              }
              this.Destination = bayDetails.destinationHubName;
              this.route = bayDetails.route;
              this.bagtype = bayDetails.bagType;
              this.bagDestinationHubId = bayDetails.destinationHubId;
              
              this.bagTypeObjData = {
                text: response.bagtype
              }
              this.flagUpdateSealNo = true
              this.$alertify.success(result.data.ReturnMessage)
              this.$refs.awbBag.focus()
              this.loadBagInShipmentList()
              if (this.BayNoList.length == 0 || this.PTLNoList.length == 0) {
                this.loadBayNos();
                this.isPTL = false;
                if (this.bayTypeName == 'PTL') {
                  this.isPTL = true;
                  this.PTLNoList = [];
                  axios({
                    method: 'GET',
                    url: apiUrl.api_url_hubops + "fetchPtlIdsforSorterBagging?currentHubId=" + this.userHubId + "&bayNo=" + this.bayNo,
                    headers: {
                      'authorization': 'authkey xB84JJ89Hd25',
                      'requestfrom': "WEB",
                      'token': this.token
                    }
                  }).then(result => {
                    if (result.data.ResultCode == 100) {
                      let ptlNos = result.data.ResponseData;
                      for (const element of ptlNos) {
                        this.PTLNoList.push({
                          text: element + " ",
                          value: element
                        })
                      }
                    } else {
                      this.$alertify.error(result.data.ReturnMessage)
                    }
                  }, error => {
                    console.error(error)
                  })
                }
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.BagLoading = false;
            console.error(error)
          })
      } else {
        this.errorBagSealNo = "The Bag Seal Number field is required."
      }

    },
    closeXBSealModel() {
      this.XBSealModel = false,
      this.IsAllowXBSeal = false
      this.xbsealreason = ''
      this.xbsealreasonErr = ''
    },
    CancelXBSeal() {
      this.IsAllowXBSeal = false
      this.xbsealreason = ''
      this.xbsealreasonErr = ''
    },
    clearXBReasonError() {
      this.xbsealreasonErr = ''
    },
    bagInscan() {
      if (this.awbBag == "") {
        this.awbBagErr = "The AWB field is required."
      } else {
        this.BagLoading = true;
        this.awbBagErr = ""
          this.input = {
            "currentHubId": this.userHubId,
            "createdBy": this.createdBy,
            "bagNumber": this.baginBagNo,
            "shippingID": this.awbBag,
            "currentHubName": this.hubName,
            "statusMarkedFrom": "WEB",
            "isManualEntry": this.manualInput,
            "bayId" : this.bayNo,
            "ptlId" : this.PtlNo,
            "cwbcode" : this.cwbcode
        }
        if (this.userid) {
          this.input.userId = this.userid;
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'bagInShipmentForSorterBagging',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              if(Object.keys(result.data.lossCategorization).length !=0){
                this.shipmentForColor = result.data.shippingId
                this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
              }
              this.invalidTokenModal = false
              this.$alertify.success(result.data.ReturnMessage)
              this.awbBag = ""
              this.manualInput = false
              this.$refs.awbBag.focus()
              this.loadBagInShipmentList();
            }
             else {
              if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length !== 0) {
                this.shipmentForColor = this.awbBag
                this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
              }
                this.invalidTokenModal = false
                this.$refs.awbBag.focus()
                this.$alertify.error(result.data.ReturnMessage)
              }
            this.BagLoading = false;
            user_tracker.checkUserIP(this.userData[0], "BaginProcess_BagInscan", this.$route.path , this.input);
          }, error => {
            this.BagLoading = false;
            console.error(error)
          })
      }
    },
    loadBagInShipmentList() {
      this.inScanList = []
      this.weight = ""
      if (this.baginBagNo) {
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'bagInShipmentList?bagNumber=' + this.baginBagNo,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              var bagTypeData = result.data.ResponseData
              var physicalweight = 0
              this.inScanList = result.data.ResponseData
              for (var i = 0; i < bagTypeData.length; i++) {
                physicalweight += parseFloat(bagTypeData[i].physicalweight)
              }
              this.weight = parseFloat(physicalweight).toFixed(2)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeBag() {
      this.printBagStickerNo = "",
      this.BagLoading = true;
      this.input = {
        "bagNumber": this.baginBagNo,
        "hubId": this.userHubId,
        "hubName": this.hubName,
        "weight": this.weight,
        "createdBy": this.createdBy,
        "statusMarkedFrom": "WEB"
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'closeBagForSorterBagging',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(async result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.printBagStickerNo = this.baginBagNo
            if(Object.keys(result.data.lossCategorization).length !=0){
              this.BagNoForColor = this.baginBagNo
						await	this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon,true);
           }
          this.resetCloseBag();
          this.weight = ""
        }else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
             this.showHideCodeIconInput();
          }
          this.BagLoading = false;
          user_tracker.checkUserIP(this.userData[0], "BaginProcess_CloseBag", this.$route.path , this.input);
        }, error => {
          this.BagLoading=false;
          console.error(error)
        })
    },

    resetCloseBag() {
      document.getElementById("bagsealno").removeAttribute("style");
      this.bagSealNumber = '',
        this.barcodecheck = 0,
        setTimeout(function() {
          document.getElementById("bagsealno").disabled = false;
        }, this.timerdisable);
      this.flagGerateBag = false
      this.flagUpdateSealNo = false
      this.awbBag = '',
      this.inScanList = [],
      this.manualInput = false
        this.weight = '',
        this.baginBagNo = '',
        this.baginBagStatus = '',
        this.baginBagType = '',
        this.loadBagInShipmentList()
        this.resetfeilds(),
        this.loadBayNos(),
      this.$validator.reset()
    },

    resetBaginProcess() {
      this.barcodeinput = false,
        this.bagSealNumber = '',
      this.flagGerateBag = false,
        this.flagUpdateSealNo = false,
        this.awbBag = '',
        this.manualInput = false
        this.weight = '',
        this.baginBagNo = '',
        this.baginBagStatus = '',
        this.baginBagType = ''
      this.printBagStickerNo = ''
      this.inScanList = [],
      this.errorBagSealNo = ''
      this.bayTypeData = { 
        text: 'Direct',
        value: 1,
      },
      this.bayTypeName ='Direct',
      this.isPTL = false,
      this.loadBagInShipmentList(),
      this.resetfeilds(),
      this.loadBayNos(),
      this.$validator.reset()
      this.showHideCodeIconInput();
      this.BagNoForColor = '';
    },
    openBagSealNoModel() {
      this.resetUpdateBagSealNoForm();
      if (this.baginBagNo == '') {
        this.oldSealNo = this.bagSealNumber
      } else {
        this.oldSealNo = this.baginBagNo
      }
      this.showBagSealNoModel = true
    },
    closeBagSealNoModel() {
      this.showBagSealNoModel = false
    },
    onGenerateBagin() {
      this.flagUpdateSealNo = false
      this.printBagStickerNo = ''
      this.errorBagSealNo = ''
      this.$validator.validateAll().then((result) => {
        if (result) {
            this.flagGerateBag = true
            this.generateBag()
          }
         else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    updateBagSealNo() {
      if (this.validUpdateBagSealNoForm()) {
        this.BagLoading=true;
        this.input = {
          "CurrentHubID": this.userHubId,
          "OldBagSealNo": this.oldSealNo,
          "NewBagSealNo": this.newSealNo,
          "SealChangedReason": this.reason,
          "LastModifiedBy": this.createdBy,
          "CurrentHubName": this.hubName,
          "statusMarkedFrom": "WEB"
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'updateBagSealNo',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.BagLoading=false;
              this.invalidTokenModal = false
              this.$alertify.success("Bag Seal No Updated Successfully.")
              this.baginBagNo = this.newSealNo
              this.showBagSealNoModel = false
              this.resetUpdateBagSealNoForm();
            } else if (result.data.ResultCode == 401) {
              this.BagLoading=false;
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.BagLoading=false;
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }

          }, error => {
            this.BagLoading=false;
            console.error(error)
          })
      }
    },
    resetModalFields() {
      this.reason = ''
      this.newSealNo = ''
      this.reasonErr = ''
      this.newSealNoErr = ''
    },
    validUpdateBagSealNoForm() {
      var flag = true;
      this.oldSealNoErr = ''
      this.newSealNoErr = ''
      this.reasonErr = ''
      if (this.oldSealNo == "") {
        flag = false
        this.oldSealNoErr = "Old Bag Seal No field is required."
      }
      if (this.newSealNo == "") {
        flag = false
        this.newSealNoErr = "New Bag Seal No field is required."
      }
      if (this.reason == "") {
        flag = false
        this.reasonErr = "Reason field is required."
      }
      return flag;
    },
    resetUpdateBagSealNoForm() {
      this.newSealNo = ""
      this.reason = ""
    },
    resetInSacn() {
      this.awbBag = ""
      this.manualInput = false
      this.awbBagErr = ""
      this.$refs.awbBag.focus()
      this.showHideCodeIconInput();
    },
    resetValidator() {
      this.$validator.reset()
    },
    loadBagDetails() {
      this.input = {}
      this.iscwbFacility = false;
      axios({
          method: 'GET',
          'url': apiUrl.allocateRuleapi_url + 'getBagDetailsForPrintStickerForSorterBagging?BagNo=' + this.printBagStickerNo+'&currentHubId='+this.userHubId,
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          if (response.ResultCode == 100) {
            if (response.ResultData.length > 0) {
              this.bagDetails = response.ResultData[0];
              this.iscwbFacility = this.bagDetails.iscwbFacility;
              this.printerSticker(this.bagDetails)
            }

          } else {
            this.bagDetails = {};
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error(error.response.statusText);
          } else {
            this.$alertify.error(error.response.statusText);
          }
          console.log(error)
        })
    },

    printerSticker(bagDetails) {
      var date = bagDetails.bagprintdate;

      let prnData = `^XA
        ^SZ2^JMA
        ^MCY^PMN
        ^PW812
        ~SD12^MD0^MTD
        ~JSN
        ~SD25^MD0
        ^JZY
        ^LH0,0^LRN
        ^XZ
        ^XA
        ^FT63,56
        ^A0N,50,50^FD${bagDetails.originhubname}^FS
        ^FO63,83
        ^BY3^BCN,170,N,N^FD>:${bagDetails.bagno}^FS
        ^FT63,301
        ^A0N,50,50^FD${bagDetails.bagno}^FS
        ^FT63,365
        ^A0N,50,50^FD${((bagDetails.iscwb==0 && this.iscwbFacility) ? '**PRIMARY BAG**' : '')}^FS
        ^FT63,420
        ^A0N,50,50^FDGroup :^FS
        ^FT280,420
        ^A0N,50,50^FD${bagDetails.GroupNameWithNo}^FS
        ^FT63,460
        ^A0N,50,50^FDDest :^FS
        ^FT280,460
        ^A0N,50,50^FD${bagDetails.destinationhubname}^FS
        ^FT63,500
        ^A0N,50,50^FDBagType :^FS
        ^FT280,500
        ^A0N,50,50^FD${bagDetails.bagtype}^FS
        ^FT63,540
        ^A0N,50,50^FDMode :^FS
        ^FT280,540
        ^A0N,50,50^FD${bagDetails.routemode}^FS
        ^FT63,580
        ^A0N,50,50^FDLane :^FS
        ^FT280,580
        ^A0N,50,50^FD${this.laneDetail}^FS
        ^FT620,580
        ^A0N,50,50^FDQty :^FS
        ^FT720,580
        ^A0N,50,50^FD${bagDetails.totalshipmentsinbag}^FS
        ^PQ1,0,1,Y
        ^XZ`;
      console.log(prnData);
      this.input = {
        prnData: prnData,
        // 'n\n' + 
        // 'M0750\n' +
        // 'O0220\n' +
        // 'V0\n' + 
        // 'f310\n' + 
        // 'SE\n' + 
        // 'D\n' + 
        // 'L\n' + 
        // 'L\n' + 
        // 'D11\n' + 
        // 'H23\n' + 
        // 'PE\n' + 
        // 'A2\n' + 
        // '1911A1202580128'+ bagDetails.originhubname + '\n' +
        // '1911A1400950090' + bagDetails.GroupNameWithNo + '\n' + 
        // '1911A1400950032Group:' + '\n' + 
        // '1911A1400750032Dest:' + '\n' + 
        // '1911A1400750080' + bagDetails.destinationhubname + '\n' + 
        // '1911A1400550032BagType:\n' +  
        // '1911A1400550120' + bagDetails.bagtype + '\n' + 
        // '1911A1400350032Mode:\n' + 
        // '1911A1400350090' + bagDetails.routemode + '\n' + 
        // '1911A1400350212Qty:\n' + 
        // '1911A1400350250' + bagDetails.totalshipmentsinbag + '\n' + 
        // '1a5208901640080' + bagDetails.bagno + '\n' + 
        // '1911A1401410080' + bagDetails.bagno + '\n' + 
        // 'Q0001\n' + 
        // 'E',
        bagNumber: this.printBagStickerNo
      }
      axios({
          method: "POST",
          url: "http://localhost:4500/printer/printbagsticker",
          data: this.input,
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          var code = error.response == undefined ? code = 0 : error.response.status;
          if (code == 500) {
            this.$alertify.error("Printer API error");
            console.log(error.response.statusText);
          } else if (error) {
            this.$alertify.error("Printer not connected")
          }
        })
    },
    setLoading(isLoading) {
      if (isLoading) {
        this.resultCount++;
        this.isLoading = true;
      } else if (this.resultCount > 0) {
        this.resultCount--;
        this.isLoading = (this.resultCount > 0);
      }
    },
    scanBagSealNumber() {
      // var textBox = document.getElementById("bagsealno");
      // textBox.onkeypress = function(e) {
      //   e = e || window.event;
      //   var charCode = e.keyCode;
      //   if (/[^\d]/.test(String.fromCodePoint(charCode))) {
      //     return false;
      //   }
      //     if (/^[0-9]/.test(String.fromCodePoint(charCode))) {
      //       return false;
      //     }
      //
      // };
    },
    removeShipment(shippingId) {
      if (shippingId) {
        this.input = {
          "parentBagNo": this.baginBagNo,
          "shippingID": shippingId,
          "userHubID": this.userHubId,
          "lastModifiedBy": this.createdBy,
          "userHubName": this.hubName,
          "statusMarkedFrom": "WEB"
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'removeBagShipment',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.loadBagInShipmentList()
              this.$alertify.success("Bag Shipment Successfully Remove")
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.$alertify.error("Shipment ID not found")
      }
    },
    }
  }



// WEBPACK FOOTER //
// ./src/views/components/SorterBagging/SorterBagging.js